module.exports = __webpack_public_path__ + "img/collectable-assets-pt1.0574f771.png";